'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _svgDefineOnce = require('@brandwatch/axiom-utils/dist/svgDefineOnce');

var _svgDefineOnce2 = _interopRequireDefault(_svgDefineOnce);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  ['subtle', 'white'].forEach(function (color) {
    (0, _svgDefineOnce2.default)('\n      <linearGradient id="ax-progress-infinite__filter--' + color + '">\n        <stop class="ax-progress-infinite__arc-gradient-stop--' + color + '" offset="0%"></stop>\n        <stop class="ax-progress-infinite__arc-gradient-stop--' + color + '" offset="50%"></stop>\n        <stop class="ax-progress-infinite__arc-gradient-stop--' + color + '" offset="90%"></stop>\n      </linearGradient>\n    ');
  });
};